import { Team } from "src/app/model/team";
import { Role } from "src/app/model/role";

export class Member {
  memberId: string;
  firstname: string;
  lastname: string;
  photoUrl: string;
  vttvPlayerId: string;
  dayOfBirth: Date;
  memberSince: number;
  roleIds: string[];
}